// extracted by mini-css-extract-plugin
var _1 = "Header-module__animateUploadProgressBarWidth--obXq4";
var _2 = "Header-module__animatedBackground--Gde9p";
var _3 = "Header-module__buttonContainer--ORvE3";
var _4 = "Header-module__collapseButton--hyoko";
var _5 = "Header-module__collapseButtonIcon--S1sNI";
var _6 = "Header-module__header--Jux6H";
var _7 = "Header-module__linkButton--AmTWy";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttonContainer", _4 as "collapseButton", _5 as "collapseButtonIcon", _6 as "header", _7 as "linkButton" }
